// import { colors } from './../../../config/styles'

export default {
	editPanel: {
		maxWidth: 600,
	},
}
